import React, { useContext, useState, useEffect } from "react";
import { SettingsContext } from "../providers/SettingsProvider";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import "../css/generalSettingsPage.scss";
import { SlidersContext } from "../providers/SlidersProvider";
import { CircularProgress, Switch } from "@mui/material";
import { usePrimariesSyncStatus } from "../customHooks/useDeltaSyncedCollection";
import { resetPrimaries } from "../helperFunctions/primaryCache";

const GeneralSettings = () => {
  const [error, setError] = useState("");

  const {
    currentTsNumber,
    currentRateNumber,
    currentQuoteNumber,
    currentJobsheetNumber,
    changePrimaryNumber,
    currentMaterialsPercentage,
    changeMaterialsPercentage,
    vat,
    toggleVat,
    draftPollingEnabled,
    toggleDraftPolling,
  } = useContext(SettingsContext);

  const [tsNumber, setTsNumber] = useState(currentTsNumber);
  const [quoteNumber, setQuoteNumber] = useState(currentQuoteNumber);
  const [jobsheetNumber, setJobsheetNumber] = useState(currentJobsheetNumber);
  const [rateNumber, setRateNumber] = useState(currentRateNumber);
  const [materialsPercentage, setMaterialsPercentage] = useState(currentMaterialsPercentage);
  // const [sliders, setSliders] = useState(
  //   Boolean(window.localStorage.getItem("sliders"))
  // );
  const [formVat, setFormVat] = useState(vat);
  const { sliders, toggleSliders } = useContext(SlidersContext);
  const { lastSyncedAt, resyncing } = usePrimariesSyncStatus();

  useEffect(() => {
    setTsNumber(currentTsNumber);
  }, [currentTsNumber]);

  useEffect(() => {
    setQuoteNumber(currentQuoteNumber);
  }, [currentQuoteNumber]);

  useEffect(() => {
    setJobsheetNumber(currentJobsheetNumber);
  }, [currentJobsheetNumber]);

  useEffect(() => {
    setRateNumber(currentRateNumber);
  }, [currentRateNumber]);

  useEffect(() => {
    setMaterialsPercentage(currentMaterialsPercentage);
  }, [currentMaterialsPercentage]);

  useEffect(() => {
    setFormVat(vat);
  }, [vat]);

  function alterNumber(type, newNumber) {
    let typedNumber = Number(newNumber);
    let goAhead = true;

    if (newNumber.length === 0) {
      setError("Needs to be filled in");
      goAhead = false;
    }

    if (Number.isNaN(typedNumber)) {
      setError("Needs to be a number");
      goAhead = false;
    }

    if (type === "timesheet") {
      setTsNumber(newNumber);
    }
    if (type === "quote") {
      setQuoteNumber(newNumber);
    }
    if (type === "jobsheet") {
      setJobsheetNumber(newNumber);
    }
    if (type === "rate") {
      setRateNumber(newNumber);
    }

    if (goAhead) {
      changePrimaryNumber(type, Number(newNumber.trim()));
    }
  }

  function alterPercentage(newNumber) {
    let typedNumber = Number(newNumber);
    let goAhead = true;

    if (newNumber.length === 0) {
      setError("Needs to be filled in");
      // console.log("Condition: Length is 0");
      typedNumber = 0;
      //goAhead = false;
      // return;
    }

    if (Number.isNaN(typedNumber)) {
      setError("Needs to be a number");
      // console.log("Condition: is NaN");
      typedNumber = 0;
    }

    setMaterialsPercentage(String(typedNumber));

    if (goAhead) {
      changeMaterialsPercentage(Number(String(typedNumber).trim()));
    }

    // changeMaterialsPercentage(newNumber);
  }

  function alterVat() {
    toggleVat(formVat);
  }

  return (
    <div className="generalSettingsPage">
      <Footer title={"Settings"} back={true}>
        {/* <button onClick={addJobDescription} className="adder">
          @
        </button> */}
      </Footer>
      {/* <h3>General Settings</h3>
      <p>{error}</p> */}
      {/* <label htmlFor="matPercentage">
        Materials Percentage
        <input
          name="matPercentage"
          id="tsNumber"
          value={materialsPercentage ?? 0}
          onChange={alterPercentage}
        />
      </label> */}
      <div className="settingsOptionsContainer">
        <div className="formLine">
          <label htmlFor="tsNumber">Timesheet Number</label>
          <input
            className="arrowLess"
            name="tsNumber"
            id="tsNumber"
            type="number"
            value={tsNumber ?? ""}
            onChange={(e) => alterNumber("timesheet", e.target.value)}
          />
        </div>

        <div className="formLine">
          <label htmlFor="quoteNumber">Quote Number</label>
          <input
            className="arrowLess"
            type="number"
            name="quoteNumber"
            id="quoteNumber"
            value={quoteNumber ?? ""}
            onChange={(e) => alterNumber("quote", e.target.value)}
          />
        </div>

        <div className="formLine">
          <label htmlFor="jobsheetNumber">Jobsheet Number</label>
          <input
            className="arrowLess"
            type="number"
            name="jobsheetNumber"
            id="jobsheetNumber"
            value={jobsheetNumber ?? ""}
            onChange={(e) => alterNumber("jobsheet", e.target.value)}
          />
        </div>

        <div className="formLine">
          <label htmlFor="rateNumber">Rate Number</label>
          <input
            className="arrowLess"
            type="number"
            name="rateNumber"
            id="rateNumber"
            value={rateNumber ?? ""}
            onChange={(e) => alterNumber("rate", e.target.value)}
          />
        </div>


        <div className="formLine">
          <label htmlFor="materialsPercentage">Materials Percentage</label>
          <input
            className="arrowLess"
            type="text"
            name="materialsPercentage"
            id="materialsPercentage"
            value={materialsPercentage ?? ""}
            onChange={(e) => alterPercentage(e.target.value)}
          />
        </div>

        <div className="formLine">
          <label htmlFor="sliders">Sliding Panes</label>

          <Switch checked={sliders} onChange={toggleSliders} />
        </div>
        <div className="formLine">
          <label htmlFor="vat">VAT (20%)</label>
          <Switch checked={formVat} onChange={alterVat} />
        </div>
        <div className="formLine">
          <label htmlFor="draftPolling">Auto-detect sent drafts</label>
          <Switch
            checked={draftPollingEnabled}
            onChange={() => toggleDraftPolling(draftPollingEnabled)}
          />
        </div>
        {/* Replaces the old "Days" window - every primary is now kept on the device and only
            changes are fetched, so this is just a way out if a device ever looks out of date
            (eg. after a primary was deleted directly in the Firebase console). */}
        <div className="formLine">
          <label htmlFor="resyncPrimaries">
            Last synced {lastSyncedAt ? new Date(lastSyncedAt).toLocaleTimeString() : "-"}
          </label>
          <button
            type="button"
            id="resyncPrimaries"
            className="resyncButton"
            onClick={resetPrimaries}
            disabled={resyncing}
          >
            {resyncing ? (
              <>
                <CircularProgress size={16} color="inherit" />
                Syncing...
              </>
            ) : (
              "Re-sync all data"
            )}
          </button>
        </div>
      </div>

      <div className="settingsLinks">
        <Link to="/settings/rates">Rates</Link>
        {/* <Link to="/settings/operatives">Operatives</Link> */}
        <Link to="/settings/customers">Customers</Link>
        <Link to="/settings/business-information">Business Information</Link>
        <Link to="/settings/linkedAccounts">Linked Accounts</Link>
        <Link to="/settings/export">Export</Link>
        <Link to="/settings/ai-features">AI Features</Link>
        <Link to="/settings/templates">Templates</Link>
        {/* <Link to="/settings">General</Link> */}
      </div>
    </div>
  );
};

export default GeneralSettings;
